<template>
  <div className="admin-grid">
    <article class="searchDataTable input-field">
      <v-text-field prepend-icon="search" label="Rechercher" v-model="search" />
    </article>
    <v-dialog
      class="admin-dialog"
      v-model="dialog.open"
      max-width="95%"
      max-height="80%"
    >
      <site-interface
        mode="site"
        :dialog="dialog"
        @close="closeSiteDialog()"
        @update="$emit('update')"
        @edit="goToEditMode()"
        @cancel-edit="cancelEditMode()"
      />
    </v-dialog>
    <v-skeleton-loader v-if="!sites" type="table" tile class="mx-auto" />
    <v-data-table
      v-else
      :expanded.sync="expanded"
      :headers="getHeaders()"
      :items="sites"
      :search="search"
      item-key="refSite.id"
      single-expand
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="btn-floating scdf-yellow"
              fab
              v-on="on"
              @click="expanded[0] === item ? close() : expand(item)"
            >
              <v-icon>{{ expanded[0] === item ? 'close' : 'edit' }}</v-icon>
            </v-btn>
          </template>
          Editer ce site
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              v-on="on"
              class="btn-floating scdf-red"
              @click="deleteSite(item)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          Supprimer ce site
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              v-on="on"
              class="btn-floating scdf-blue"
              @click="openSiteDialog(item)"
            >
              <v-icon>people</v-icon>
            </v-btn>
          </template>
          Visualiser les utilisateurs rattachés à ce site
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="getHeaders().length">
          <v-card flat width="100%">
            <v-card-text>
              <site-form
                title="Editer les informations"
                :site="item"
                @edit-site="$emit('edit-site', $event)"
                @close-expansion="close()"
              />
            </v-card-text>
          </v-card>
        </td>
      </template>
      <template v-slot:pageText="props">
        Lignes {{ props.pageStart }} - {{ props.pageStop }} sur
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SiteForm from '@/components/Form/SiteForm';
import axios from 'axios';
import SiteInterface from './SiteInterface';

export default {
  name: 'site-grid',
  components: {
    SiteForm,
    SiteInterface,
  },

  data() {
    return {
      dialog: {
        editing: false,
        open: false,
        site: null,
      },
      expanded: [],
      previousActionState: null,
      snackbar: false,
      timeout: 4000,
      text: null,
      selected: null,
      loading: false,
      pagination: {
        sortBy: 'email',
      },
      search: '',
      code: null,
      nom: null,
      region: null,
      section: null,
      societe: null,
    };
  },

  props: {
    sites: {
      type: Array,
      default: null,
    },
  },

  methods: {
    ...mapActions(['removeSite']),
    openSiteDialog(site) {
      this.dialog = {
        editing: false,
        site,
        open: true,
      };
    },

    closeSiteDialog() {
      this.dialog = {
        editing: false,
        site: null,
        open: false,
      };
    },

    goToEditMode() {
      this.dialog = {
        editing: true,
        site: this.dialog.site,
        open: this.dialog.open,
      };
    },

    cancelEditMode() {
      this.dialog = {
        editing: false,
        site: this.dialog.site,
        open: this.dialog.open,
      };
    },

    deleteSite(site) {
      if (confirm('Voulez-vous vraiment supprimer ce site ?')) {
        axios({
          method: 'delete',
          url:
            process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_SITE_REPOSITORY +
            '/' +
            site.refSite.id,
          headers: {
            user: this.$store.state.user,
          },
        })
          .then(() => {
            this.$toasted.show('Site supprimé', { type: 'success' });
            this.removeSite(site.refSite.id);
          })
          .catch(() => {
            this.$toasted.show(
              'Le site ne peut être supprimé car il est présent dans le scénario chargé ou des viewers y sont rattachés.',
              {
                type: 'error',
              }
            );
          });
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    getHeaders() {
      return [
        { text: 'Code', value: 'refSite.' + process.env.VUE_APP_SITE_CODE },
        { text: 'Nom', value: 'refSite.' + process.env.VUE_APP_SITE_NOM },
        { text: 'Type', value: 'typeName' },
        {
          text: 'Section',
          value: 'sectionName',
        },
        {
          text: 'Région',
          value: 'regionName',
        },
        {
          text: 'Société',
          value: 'societeName',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ];
    },
    expand(item) {
      this.close();
      this.expanded.push(item);
    },
    close() {
      this.expanded = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-floating {
  margin: 5px;
}
</style>
